export enum TrackingCategories {
	ACCOUNT_PAGE = 'AccountPage',
}
